import {makeStyles} from '@material-ui/core';
import {DEFAULT_RED_COLOR} from 'src/style/variable';

export const ccmCreatePlanDialogStyles = makeStyles(() => ({
  root: {
    '& .MuiSelect-nativeInput': {
      border: 'none',
      height: '2rem',
      paddingRight: '2rem'
    }
  },
  input: {
    width: '100%',
    borderRadius: '4px'
  },
  deleteIconStyle: {
    fontSize: '2.3rem',
    '&:hover': {
      color: DEFAULT_RED_COLOR
    }
  },
  dialogBody: {
    maxHeight: '50vh',
    position: 'relative'
  },
  noPlan: {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
  },
  plansWrapper: {
    display: 'flex',
    gap: '1rem'
  },
  taskNameWrapper: {
    flex: 8
  },
  formControl: {
    paddingBottom: '0'
  },
  taskTypeWrapper: {
    flex: 4
  },
  deleteIconButton: {
    padding: 0,
    alignSelf: 'flex-start',
    marginTop: '1.7rem'
  },
  dialogActions: {
    justifyContent: 'space-between',
    paddingLeft: '24px',
    alignItems: 'center'
  },
  addButton: {
    height: '2.4rem',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    fontSize: '1.06rem',
    width: '9rem',
    borderRadius: '3px'
  },
  planTaskTypeTitleWrapper: {
    marginBottom: '8px'
  }
}));
